import React from "react";

export const PaymentCardIllustration = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="264" height="113" fill="none">
    <path
      fill="url(#paint0_linear)"
      fillRule="evenodd"
      d="M134.4 10a47.4 47.4 0 00-28.7 10.8C93.4 31.1 84.9 44.3 86.2 61.1a35.3 35.3 0 0022.4 30.5 58 58 0 0054.8-2.5l4.8-2.7c16.8-9 21.8-26.7 19.4-42.3-1.1-7.7-4.7-14-10.5-19.1a55.3 55.3 0 00-42.7-15z"
      clipRule="evenodd"
    />
    <path
      fill="#0A3B5F"
      d="M163.6 9.1L162 6c-.6-1.4-1.8-1.4-3.2-.8-3 1.3-6 2.9-8.8 4.4-8.3 4.5-36.2 19-44.3 23.4-4.3 2.3-7.4 2.7-5 7.2l2.7 5.7 62.4-32.5-2.2-4.3z"
    />
    <path
      fill="#5FCE8C"
      d="M165.8 13.4L103.4 46l8.2 16.4c1.4 2.6 4.6 11.3 7.5 9.6l5.8-3.2c16-8.8 26.9-13.9 43-22.5l9-4.6c3.5-1.8-2.4-10.7-3.7-13.2l-7.4-15z"
    />
    <path fill="#127CCB" d="M160.8 24l-9 4.6 3 6 9-4.8-3-5.9z" />
    <path
      fill="#fff"
      d="M128 58.4l-.5-.9-8.2 4.3.5.9 8.1-4.3zM137.4 53.4l-.4-.8-7.3 3.8.4.8 7.3-3.8zM142 44.4l-.5-.9-24.9 13 .5.9 24.8-13z"
    />
    <path
      fill="#F19020"
      d="M141.4 84c.3 1.1-.1 5.8-4.7 7.5l-5.1 1.8c-5.6 1.8-15.1 5.5-23.5 8.6a6 6 0 01-7.7-3.6L94 80.1c4.3-2 7.7-8.5 10-13.1.6-2.2 2.3-8.8 4.5-13.4 1.4-3 6.8-1.5 7 2.1.3 4.7-.1 10.6-.5 13.9l6.8-3.5c7.6-3.9 15.4-7.7 23.2-11.4 1.4-.7 3-1 4.7-1.2 2.8-.4 4.6 4.6 2.2 6.3-2.4 1.7-18.8 11-18.8 11s6-2.4 7.7 1.8c1.6 4.2-5.4 8-5.4 8 5.3-.4 5.8 2.5 6 3.5z"
    />
    <path
      fill="#FBAF17"
      fillRule="evenodd"
      d="M124.3 95.9a236 236 0 0111-4l1.5-.5a7.2 7.2 0 004.7-7.5c-.3-1-1-3.8-6-3.3 0 0 7-3.9 5.3-8.1-1.6-4.2-7.7-1.8-7.7-1.8s16.4-9.4 18.8-11c2.4-1.7.7-6.7-2.1-6.4-1.7.2-3.3.5-4.8 1.2L121.8 66l-1.4.7-5.3 2.7c.3-3.2.7-9.2.4-13.8-.2-3.7-5.6-5.2-7-2.2a83.5 83.5 0 00-4.4 13.4C101.7 71.5 98.3 78 94 80l.4 1.1c3.9 3.9 8.7 7 14.3 9.6 5.2 2.3 10.4 4 15.6 5.2z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="88.6"
        x2="186.6"
        y1="73"
        y2="37.3"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E0F2FF" />
        <stop offset="1" stopColor="#EDFCFF" />
      </linearGradient>
    </defs>
  </svg>
);
